require('../styles/scss/main.scss')

require('jquery')

require('./vendor/jquery.fullPage.js')
require('./vendor/jquery.teletype.js')
require('./vendor/greensock/TweenMax.min.js')
require('./vendor/google-analytics.js')

require('./modules/nav-menu.js')
require('./modules/type-text.js')
require('./modules/fullpagejs-manager.js')



//////////////////
// WEBPACK FOOTER
// ./js/entry.js
// module id = 0
// module chunks = 0